import React from 'react';
import { formatarMoeda } from '../../utils/formatadores';

const LinhaContaBancaria = ({ conta, onTotalContasClick, onVencidasClick, onProximasClick }) => {
  return (
    <tr className="hover:bg-[color:var(--surface-muted)]">
      <td className="px-4 py-3">
        <div className="text-sm font-medium text-[color:var(--text-primary)] truncate" title={conta.nome}>
          {conta.nome}
        </div>
        <div className="text-xs text-[color:var(--text-muted)]">
          {conta.fornecedoresUnicos} fornecedor{conta.fornecedoresUnicos !== 1 ? 'es' : ''}
        </div>
      </td>
      <td className="px-4 py-3 text-sm text-[color:var(--text-primary)]">
        {onTotalContasClick ? (
          <button
            onClick={() => onTotalContasClick(conta)}
            className="cursor-pointer hover:text-[color:var(--accent)] hover:underline transition-colors"
            title="Clique para ver todas as contas desta conta bancária"
          >
            {conta.totalContas}
          </button>
        ) : (
          <span>{conta.totalContas}</span>
        )}
      </td>
      <td className="px-4 py-3 text-sm font-medium text-[color:var(--text-primary)]">
        {formatarMoeda(conta.valorTotal)}
      </td>
      <td className="px-4 py-3 text-sm text-emerald-500">
        {formatarMoeda(conta.valorPago)}
      </td>
      <td className="px-4 py-3 text-sm text-red-500">
        {formatarMoeda(conta.valorAberto)}
      </td>
      <td className="px-4 py-3 text-sm text-red-500">
        {onVencidasClick && conta.contasVencidas > 0 ? (
          <button
            onClick={() => onVencidasClick(conta)}
            className="cursor-pointer hover:text-red-500 hover:underline transition-colors"
            title="Clique para ver as contas vencidas desta conta bancária"
          >
            {conta.contasVencidas}
          </button>
        ) : (
          <span>{conta.contasVencidas}</span>
        )}
      </td>
      <td className="px-4 py-3 text-sm text-orange-500">
        {onProximasClick && conta.proximasVencimento > 0 ? (
          <button
            onClick={() => onProximasClick(conta)}
            className="cursor-pointer hover:text-orange-500 hover:underline transition-colors"
            title="Clique para ver as contas próximas ao vencimento desta conta bancária"
          >
            {conta.proximasVencimento}
          </button>
        ) : (
          <span>{conta.proximasVencimento}</span>
        )}
      </td>
    </tr>
  );
};

export default LinhaContaBancaria;





